var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClip = function SvgClip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1717 4.99987L5.58616 11.5854C5.39516 11.7698 5.2428 11.9905 5.13799 12.2345C5.03318 12.4785 4.97801 12.7409 4.97571 13.0065C4.9734 13.272 5.024 13.5353 5.12455 13.7811C5.22511 14.0269 5.3736 14.2502 5.56137 14.4379C5.74914 14.6257 5.97243 14.7742 6.21821 14.8748C6.46398 14.9753 6.72732 15.0259 6.99286 15.0236C7.2584 15.0213 7.52082 14.9661 7.76481 14.8613C8.0088 14.7565 8.22947 14.6042 8.41395 14.4132L14.8275 7.82765C15.556 7.0733 15.9592 6.06297 15.9501 5.01426C15.941 3.96555 15.5203 2.96238 14.7787 2.2208C14.0372 1.47922 13.034 1.05858 11.9853 1.04947C10.9366 1.04035 9.92624 1.4435 9.17189 2.17208L2.75738 8.75658C1.63215 9.88181 1 11.4079 1 12.9993C1 14.5906 1.63215 16.1167 2.75738 17.2419C3.8826 18.3672 5.40874 18.9993 7.00006 18.9993C8.59137 18.9993 10.1175 18.3672 11.2427 17.2419L17.4993 10.9994",
    stroke: "#262C39",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clip.a3444dc9.svg";
export { ForwardRef as ReactComponent };